export class ProdutoCampanhaCliente {
  public id: number;
  public id_product_campanha: number;
  public idcliente: number;
  public data_inclusao: Date;
  public name: string;

  constructor() { }
}
